"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var crypto_js_1 = __importDefault(require("crypto-js"));
// generates private seed with the given parameters in the correct structure
function generatePrivateSeed(_a) {
    var publicSeed = _a.publicSeed, publicKey = _a.publicKey, hashStart = _a.hashStart, hashEnd = _a.hashEnd;
    var hash = "" + hashStart + publicSeed + "&" + publicKey + hashEnd;
    return crypto_js_1.default.SHA256(hash).toString();
}
exports.default = generatePrivateSeed;
//# sourceMappingURL=generatePrivateSeed.js.map